export default {
  errorGettingOpportunities: {
    id: 'bo_sellers-buyback-opportunities-error-getting-opportunities',
    defaultMessage: 'Error getting opportunities',
  },
}
